<template>
    <div class="filter-container">
       
            <!-- 区域 -->
            <el-row class="filter-row">
                <el-col :span="1" class="label">位置：</el-col>
                <el-col :span="23">
                    <div class="filter-tabs">
                        <div 
                            class="filter-tab" 
                            :class="{ active: regionstate }"
                            @click="changestates('region')"
                        >
                            区域
                            <i :class="regionstate ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                        </div>
                        <div 
                            class="filter-tab"
                            :class="{ active: ticketstate }"
                            @click="changestates('ticket')"
                        >
                            地铁线
                            <i :class="ticketstate ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                        </div>
                    </div>
                </el-col>
            </el-row>

            <!-- 地铁线选项 -->
            <el-row v-show="ticketstate">
                <el-col :offset="1" :span="23">
                    <div class="filter-options">
                        <span 
                            class="option-item"
                            :class="{ active: ticketChangeId == '-1' }"
                            @click="checkedTicket('-1', '', '')"
                        >全部</span>
                        <span 
                            v-for="(item1, index1) in ticketList" 
                            :key="index1"
                            class="option-item"
                            :class="{ active: ticketChangeId == index1 }"
                            @click="checkedTicket(index1, item1.id, item1.metroStation)"
                        >{{ item1.name }}</span>
                    </div>
                </el-col>
            </el-row>

            <!-- 区域选项 -->
            <el-row v-show="regionstate">
                <el-col :offset="1" :span="23">
                    <div class="filter-options">
                        <span 
                            class="option-item"
                            :class="{ active: regionChangeId == '-1' }"
                            @click="getBusinessList('-1', '-1')"
                        >全部</span>
                        <span 
                            v-for="(item, index) in cityregion" 
                            :key="index"
                            class="option-item"
                            :class="{ active: regionChangeId == index }"
                            @click="getBusinessList(item.id, index)"
                        >{{ item.name }}</span>
                    </div>
                </el-col>
            </el-row>

            <!-- 商圈选项 -->
            <el-row v-show="businessList && regionstate">
                <el-col :offset="1" :span="23">
                    <div class="filter-options">
                        <span 
                            v-if="businessList.length > 0"
                            class="option-item"
                            :class="{ active: regionchildId == '-1' }"
                            @click="getregionchild('-1', '-1')"
                        >全部</span>
                        <span 
                            v-for="(item, index) in businessList" 
                            :key="index"
                            class="option-item"
                            :class="{ active: regionchildId == index }"
                            @click="getregionchild(item.id, index)"
                        >{{ item.name }}</span>
                    </div>
                </el-col>
            </el-row>
        
    </div>
</template>

<script>
export default {
    data() {
        return {
            regionstate: true, //选择区域
            ticketstate: false, //选择地铁线
            tenantCode: this.$store.state.tenantCode,
            regionChangeId: "-1",
            ticketChangeId: "-1",
            regionchildId: "-1",
            metroChangeId: "-1", //选择的地铁站id
            allBusiness: [],
            businessList: [],
            ticketList: [], //地铁
            metroStation: [], //根据出的地铁线的地铁站
            ticketchecked: "", //选择的地铁和线地铁站
            cityregion: [], //行政区域
            regionCheckList: [], //区域多选
        };
    },
    props: {
        showtype: {
            type: String,
            default: "",
        },
        params: {
            type: String,
            default: '',
        },
        initBusiness: {
            type: String,
            default: ''
        },
        initDistrict: {
            type: String,
            default: ''
        }
    },
    watch: {
        params(val) {
            if (val) {
                let params = JSON.parse(val);
                let keysname = Object.keys(params)[0];

                if (keysname === "qy") {
                    console.log(this.cityregion);
                    this.$nextTick(function () {
                        this.cityregion.forEach((it, index) => {
                            console.log(it, params.qy);
                            if (it.id == params.qy) {
                                this.regionChangeId = index;
                            }
                        });
                    });
                }
            }
        },
        initDistrict: {
            handler(newVal) {
                if (newVal) {
                    // 找到对应的区域索引
                    const index = this.cityregion.findIndex(item => item.id === newVal);
                    if (index !== -1) {
                        // 选中区域
                        this.getBusinessList(newVal, index);
                    }
                }
            },
            immediate: true
        },
        initBusiness: {
            handler(newVal) {
                if (newVal) {
                    // 等待商圈列表加载完成后选中对应商圈
                    this.$nextTick(() => {
                        if (this.businessList.length > 0) {
                            const index = this.businessList.findIndex(item => item.id === newVal);
                            if (index !== -1) {
                                this.getregionchild(newVal, index);
                            }
                        }
                    });
                }
            },
            immediate: true
        }
    },
    components: {},
    created() {
        this.getcityregion();
        this.getAllBusiness();
        this.getTicket();
    },
    mounted() {
        if (this.defaultBusiness) {
            // 设置默认商圈
            this.setDefaultBusiness(this.defaultBusiness);
        }
        if (this.defaultDistrict) {
            // 设置默认区域
            this.setDefaultDistrict(this.defaultDistrict);
        }
    },
    methods: {
        // 城市行政区
        getcityregion() {
            var tenantCode = { tenantCode: this.tenantCode };
            let cityList = this.$store.state.cityregion;
            if (cityList.length == 0) {
                this.$get(this.$api.common.cityregion, tenantCode)
                    .then((res) => {
                        // console.log("城市行政区", res);
                        if (res.code == 0) {
                            this.cityregion = res.data;
                            this.$store.commit("getRegion", res.data);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            } else {
                this.cityregion = cityList;
            }
        },
        // 获取所有商圈列表
        getAllBusiness() {
            var tenantCode = { tenantCode: this.tenantCode };

            this.$get(this.$api.common.allBusiness, tenantCode)
                .then((res) => {
                    // console.log("所有商圈列表", res);
                    if (res.code == 0) {
                        this.allBusiness = res.data;
                        // this.$emit("allBussileList", res.data);
                        this.$store.commit("allBussileList", res.data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // 按区域id获取商圈列表
        async getBusinessList(code, index) {
            console.log("商圈", code);
            this.regionCheckList = [];
            this.businessList = [];
            
            if (code == "-1") {
                this.$emit("getBusinessCode", "");
                this.$emit("getRegionId", "");
                this.regionChangeId = index;
            } else {
                this.$emit("getBusinessCode", code);
                this.regionChangeId = index;
                
                try {
                    const res = await this.$get(this.$api.common.businessList, { districtCode: code });
                    if (res.code == 0) {
                        this.businessList = res.data;
                        
                        // 如果有初始商圈值，选中对应商圈
                        if (this.initBusiness) {
                            const businessIndex = this.businessList.findIndex(item => item.id === this.initBusiness);
                            if (businessIndex !== -1) {
                                this.getregionchild(this.initBusiness, businessIndex);
                            }
                        }
                    }
                } catch (err) {
                    console.error('获取商圈列表失败:', err);
                }
            }
        },
        // 子区域
        getregionchild(code, index) {
            if (code == "-1") {
                this.$emit("getRegionId", "");
            } else {
                this.$emit("getRegionId", code);
            }
            this.regionchildId = index;
        },

        // 获取地铁线
        getTicket() {
            var tenantCode = { tenantCode: this.tenantCode };
            this.$get(this.$api.common.metroList, tenantCode)
                .then((res) => {
                    // console.log("地铁列表", res);
                    if (res.code == 0) {
                        this.ticketList = res.data;
                        this.$store.commit("ticketList", res.data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        //  地铁站
        getticketList(it, index) {
            this.metroChangeId = index;
            this.$emit("getMetro", it);
        },
        // 选择的地铁线
        checkedTicket(index, id, arr) {
            this.ticketChangeId = index;
            if (arr != "") {
                this.metroStation = arr;
            } else {
                this.metroStation = [];
                this.$emit("getMetro", "");
            }

            this.$emit("getTicketline", id);
        },
        changestates(type) {
            if (type == "region") {
                this.$emit("getMetro", "");
                this.$emit("getTicketline", "");
                this.regionChangeId = "-1";
                this.regionchildId = "-1";
                if (this.regionstate) {
                    this.regionstate = false;
                    this.ticketstate = true;
                } else {
                    this.regionstate = true;
                    this.ticketstate = false;
                }
            } else {
                this.$emit("getRegionId", "");
                this.$emit("getBusinessCode", "");
                this.metroChangeId = "-1";
                this.ticketChangeId = "-1";
                if (this.ticketstate) {
                    this.ticketstate = false;
                    this.regionstate = true;
                } else {
                    this.ticketstate = true;
                    this.regionstate = false;
                }
            }
        },
        setDefaultBusiness(businessId) {
            // 根据 businessId 设置默认选中的商圈
            // 具体实现依赖于你的 filterlist 组件的结构
        },
        setDefaultDistrict(districtId) {
            // 根据 districtId 设置默认选中的区域
            // 具体实现依赖于你的 filterlist 组件的结构
        }
    },
};
</script>

<style lang="scss" scoped >
.filter-container {
    //width: 75rem;
    margin: 0 auto;
    background: #f7f7f7;
    border-radius: 4px 4px 0 0;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
    padding: 15px 20px;
}

.filter-row {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
}

.filter-options-row {
    margin-bottom: 10px;
    
    &:last-child {
        margin-bottom: 0;
    }
}

.label {
    color: #333;
    font-size: 14px;
    font-weight: 600;
    line-height: 32px;
}

.filter-tabs {
    display: flex;
    gap: 30px;
    align-items: center;
}

.filter-tab {
    position: relative;
    padding: 6px 12px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    transition: all 0.3s ease;
    border-radius: 4px;

    i {
        margin-left: 5px;
        font-size: 12px;
    }

    &:hover {
        color: #DA251D;
    }

    &.active {
        color: #DA251D;
        font-weight: 600;
        background: rgba(218, 37, 29, 0.05);
    }
}

.filter-options {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px 0;
}

.option-item {
    display: inline-block;
    padding: 4px 12px;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    border-radius: 4px;
    transition: all 0.3s ease;
    margin-right: 10px;
    margin-bottom: 8px;

    &:hover {
        color: #DA251D;
    }

    &.active {
        color: #DA251D;
        font-weight: 600;
        background: rgba(218, 37, 29, 0.05);
    }
}


</style>



// WEBPACK FOOTER //
// src/components/filter.vue